module.exports = __webpack_public_path__ + "img/unusual.61d71a05.png";